import { StockType } from 'types/stock'
import { Action, Dispatch } from 'redux'
import { State } from 'index'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { db, FirebaseDocRefType, FirebaseDocumentDataType } from 'firebase/index'
import { fetchBreadRefsByManufacturerRef, mergeCheckoutItems } from 'reducks/checkout/operations'
import { fetchOrdersAction } from 'reducks/checkout/actions'
import { sumCheckoutItemsAmount } from 'lib/helper'

const saveBulkStocksAmount = (stocks: StockType[], amount: number, date: string) => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    dispatch(showLoadingAction())
    const storeRef = getState().auth.store_ref
    const manufacturerRef: FirebaseDocRefType = getState().auth.manufacturer_ref
    let breadRefs: FirebaseDocRefType[] = []
    const isSacriStationMode = typeof manufacturerRef !== 'undefined'

    // 販売元店舗がsacri stationを表示する場合、自店舗の決済のみに絞り込む
    if (isSacriStationMode) {
      breadRefs = await fetchBreadRefsByManufacturerRef(storeRef, manufacturerRef)
      if (breadRefs.length === 0) {
        dispatch(fetchOrdersAction([]))
        dispatch(hideLoadingAction())
        return
      }
    }

    const snapshots: FirebaseDocumentDataType = await storeRef
      .collection('store_checkouts')
      .where('status', '==', 'succeeded')
      .where('date', '==', date)
      .where('type', '==', 'daily')
      .get()

    const items = await mergeCheckoutItems(snapshots, breadRefs)
    const batch = db.batch()

    for (let i = 0; i < stocks.length; i = (i + 1) | 0) {
      const stock = stocks[i]
      if (!stock.stock_ref || stock.is_deleted) continue
      const _items = items.filter((item) => {
        return stock.bread_ref.id === item.bread_ref.id && stock.pickupable_time === item.pickupable_time
      })
      const nextStock = amount + sumCheckoutItemsAmount(_items)
      batch.set(stock.stock_ref, { stock: nextStock }, { merge: true })
    }

    return batch
      .commit()
      .then(() => {
        dispatch(hideLoadingAction())
      })
      .catch((error) => {
        console.error(error)
        dispatch(hideLoadingAction())
      })
  }
}

export default saveBulkStocksAmount
